module.exports = __webpack_public_path__ + "img/716-03bdec.png";